import { render, staticRenderFns } from "./LinkedMatters.vue?vue&type=template&id=7224eba0"
import script from "./LinkedMatters.vue?vue&type=script&lang=js"
export * from "./LinkedMatters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports